import React from 'react'

import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppHeroSection from '../../../../subscreens/customer/dashboard/apphome/appherosection/AppHeroSection';
import AppHomeServicesection from '../../../../subscreens/customer/dashboard/apphome/apphomeservicesection/AppHomeServicesection';
import NearForYouFinal from '../../../../subscreens/customer/dashboard/apphome/nearforyou/NearForYou';
import TopWorkers from '../../../../subscreens/customer/dashboard/apphome/topworkers/TopWorkers';
const AppHome = () => {
  return (
    <>
<AppNavbar/>
<AppHeroSection />
{/* <AppHomeServicesection /> */}
<NearForYouFinal/>
<TopWorkers/>
</>
  )
}

export default AppHome;